import type { Behavior } from '@capture/shared';

interface Props {
  behavior: Extract<Behavior, { kind: 'transform' }>;
  onChange: (b: Behavior) => void;
  fieldNames: string[];
  advanced: boolean;
}

const OPS = ['uppercase', 'lowercase', 'trim', 'regex-replace', 'pad-left', 'pad-right'] as const;

export function TransformBody({ behavior, onChange, advanced }: Props) {
  const params = (behavior.params ?? {}) as Record<string, unknown>;

  return (
    <div className="transform-body">
      <label>
        Operation
        <select value={behavior.op} onChange={(e) => onChange({ ...behavior, op: e.target.value })}>
          {OPS.map((o) => <option key={o} value={o}>{o}</option>)}
        </select>
      </label>

      {behavior.op === 'regex-replace' && (
        <>
          <label>Pattern <input value={String(params.pattern ?? '')} onChange={(e) => onChange({ ...behavior, params: { ...params, pattern: e.target.value } })} /></label>
          <label>Replacement <input value={String(params.replacement ?? '')} onChange={(e) => onChange({ ...behavior, params: { ...params, replacement: e.target.value } })} /></label>
        </>
      )}
      {(behavior.op === 'pad-left' || behavior.op === 'pad-right') && (
        <label>Width <input type="number" value={String(params.width ?? '')} onChange={(e) => onChange({ ...behavior, params: { ...params, width: Number(e.target.value) } })} /></label>
      )}

      {advanced && (
        <label>
          Raw params (JSON)
          <textarea rows={3} value={JSON.stringify(params, null, 2)} onChange={(e) => {
            try { onChange({ ...behavior, params: JSON.parse(e.target.value) }); } catch { /* ignore */ }
          }} />
        </label>
      )}
    </div>
  );
}
